import { Auth } from '@chocolate-soup-inc/cs-api-consumer-utils';
import { CommonButton, Icon, styleClassNames, useAuthContext } from '@chocolate-soup-inc/cs-frontend-components';
import styles from './Header.module.scss';

const Header = () => {
  const { user } = useAuthContext();
  //console.log('user?', user);
  return (
    <div className={styleClassNames.appHeader}>
      <div className={styles.session}>
        <Icon icon='featured_seasonal_and_gifts' />
        <span>Chocolate Soup</span>
      </div>
      <div className={styles.session}>
        <Icon icon='person' />
        {user?.name && <span>{user.name}</span>}
        <CommonButton onClick={() => Auth.signOut()} label='Logout' variant='filled' />
      </div>
    </div>
  );
};

export default Header;
